import { useState } from 'react';
import { Button } from '@mui/material';
import * as Yup from 'yup';
import { SaveHookFormDialog } from '../../../components/save-hook-form.dialog';
import { projectsApiKeyStore } from '../../../api/projects-api-key-store';
import { BuildingFloorForm } from '../project-forms/building-floor.form';
import { Building } from '../../../models/building';

interface CreateBuildingFloorButtonProps {
  building: Building;
  projectID: string;
  onBuildingFloorCreated: (data: any) => void;
}
const validationSchema = Yup.object().shape({
  floorData: Yup.object().shape({
    unitsCount: Yup.string().required('Unit count is required'),
    floorNo: Yup.string().required('Floor number is required'),
  }),
});

export const CreateBuildingFloorButton = ({
  projectID,
  building,
  onBuildingFloorCreated,
}: CreateBuildingFloorButtonProps) => {
  const [newBuilding, setNewBuilding] = useState<any>();

  const handleDialogClose = () => {
    setNewBuilding(undefined);
  };

  const handleAddBuildingFloor = () => {
    setNewBuilding({ floorName: '' });
  };

  const formatSubmitData = (data: any) => {
    const { buildingID, buildingName } = building;
    return { projectID, buildingID, buildingName, ...data.floorData };
  };

  return (
    <>
      <div style={{ display: 'flex', justifyContent: 'flex-end', width: '100%' }}>
        <Button
          className="btn btn-primary"
          variant="text"
          sx={{ p: 0, m: 0, mr: 1, mb: 1 }}
          onClick={handleAddBuildingFloor}
        >
          Add Floor
        </Button>
      </div>
      {newBuilding && (
        <SaveHookFormDialog
          title={'CREATE FLOOR'}
          config={{
            saveConfig: projectsApiKeyStore.createFloor(),
          }}
          data={newBuilding}
          onClose={handleDialogClose}
          onSaveCompleted={onBuildingFloorCreated}
          formatSubmitdata={formatSubmitData}
          size="xs"
          yupSchema={validationSchema}
        >
          <BuildingFloorForm name="floorData" />
        </SaveHookFormDialog>
      )}
    </>
  );
};
